const state = {
  msps: [],
  selectedMspAccount: null,
};

const getters = {
  msps: (state) => state.msps,
  selectedMspAccount: (state) => state.selectedMspAccount,
};

const actions = {
  async fetchMsps({ commit }) {
    const response = await this._vm.$http.get("/restapi/msp");
    commit("setMsps", response.data);
  },

  async fetchMsp({ commit, state }, { id }) {
    const response = await this._vm.$http.get(`/restapi/msp/${id}`);
    const index = state.msps.findIndex((msp) => msp.id === response.data.id);
    if (index === -1) {
      commit("addMsp", response.data);
    } else {
      commit("updateMsp", { idx: index, msp: response.data });
    }
    commit("setSelectedMspAccount", response.data);
  },

  async createMsp({ commit }, { msp }) {
    const response = await this._vm.$http.post("/restapi/msp", msp);
    commit("addMsp", response.data);
    return response.data;
  },

  async updateMsp({ commit }, { id, msp }) {
    const response = await this._vm.$http.put(`/restapi/msp/${id}`, msp);
    commit("updateMsp", response.data);
  },

  async deleteMsp({ commit }, { id }) {
    const response = await this._vm.$http.delete(`/restapi/msp/${id}`);
    commit("deleteMsp", response.data);
  },
};

const mutations = {
  setMsps: (state, data) => (state.msps = data.data),
  setSelectedMspAccount: (state, data) => (state.selectedMspAccount = data),
  addMsp: (state, data) => state.msps.push(data),
  updateMsp: (state, data) => (state.msps[`${data.idx}`] = data.msps),
  deleteMsp: (state, data) =>
    (state.msps = state.msps.filter((msp) => msp.id != data.id)),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
